/* Carrito lateral: abre al añadir, actualiza con la Section Rendering API */
(function () {
  'use strict';

  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  var SECTION_ID = 'cart-drawer';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lastFocus = null;
  var busy = false;
  var autoPackagingRunning = false;
  var saveTimer = null;
  var giftDirty = false;

  function qs(sel, ctx) { return (ctx || drawer).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || drawer).querySelectorAll(sel)); }

  function config() {
    var el = qs('[data-cart-drawer-config]');
    if (!el) return { strings: {} };
    try { return JSON.parse(el.textContent); } catch (e) { return { strings: {} }; }
  }

  function url(path) { return ROOT + path.replace(/^\//, ''); }

  function request(path, data) {
    return fetch(url(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data || {})
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) {
          var err = new Error(json.description || json.message || 'Cart error');
          err.status = res.status;
          throw err;
        }
        return json;
      });
    });
  }

  function getCart() {
    return fetch(url('cart.js'), { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* ---------- Render ---------- */

  function sectionWrapper() {
    return document.getElementById('shopify-section-' + SECTION_ID);
  }

  function captureState() {
    var scroller = qs('.cd');
    var body = qs('.cd__body');
    var state = {
      open: [],
      values: {},
      scroll: scroller ? scroller.scrollTop : 0,
      bodyScroll: body ? body.scrollTop : 0
    };
    qsa('details[data-acc]').forEach(function (d) { if (d.open) state.open.push(d.getAttribute('data-acc')); });
    qsa('[data-preserve]').forEach(function (el) {
      state.values[el.getAttribute('data-preserve')] = el.type === 'checkbox' ? el.checked : el.value;
    });
    return state;
  }

  function restoreState(state) {
    qsa('details[data-acc]').forEach(function (d) {
      if (state.open.indexOf(d.getAttribute('data-acc')) !== -1) d.open = true;
    });
    qsa('[data-preserve]').forEach(function (el) {
      var key = el.getAttribute('data-preserve');
      if (!(key in state.values)) return;
      if (el.type === 'checkbox') el.checked = state.values[key];
      else el.value = state.values[key];
    });
    toggleGiftFields();
    var scroller = qs('.cd');
    var body = qs('.cd__body');
    if (scroller) scroller.scrollTop = state.scroll;
    if (body) body.scrollTop = state.bodyScroll;
  }

  function updateCount() {
    var content = qs('[data-cart-drawer-content]');
    if (!content) return;
    var count = content.getAttribute('data-item-count');
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    var tab = document.querySelector('[data-cart-drawer-tab]');
    if (tab) tab.hidden = !(parseInt(count, 10) > 0);
  }

  function refresh() {
    return fetch(url('?section_id=' + SECTION_ID), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('shopify-section-' + SECTION_ID);
        var current = sectionWrapper();
        if (!fresh || !current) return;
        var state = captureState();
        current.innerHTML = fresh.innerHTML;
        restoreState(state);
        updateCount();
        initExpressButtons();
      })
      .then(ensureAutoPackaging);
  }

  /* Botones de pago rápido: Shopify los inicializa al cargar la página; tras refrescar hay que volver a hacerlo */
  function initExpressButtons() {
    try {
      if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
        window.Shopify.PaymentButton.init();
      }
    } catch (e) {
      console.warn('Express buttons init error:', e);
    }
  }

  function setLoading(on) {
    busy = on;
    drawer.classList.toggle('is-loading', on);
  }

  function run(task) {
    if (busy) return Promise.resolve();
    setLoading(true);
    showError('');
    return task()
      .catch(function (err) {
        var message = err && err.status === 422 && err.message ? err.message : config().strings.error;
        return refresh()
          .catch(function () {})
          .then(function () { showError(message); });
      })
      .then(function () { setLoading(false); }, function () { setLoading(false); });
  }

  function showError(text) {
    var el = qs('[data-cd-error]');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  }

  /* ---------- Abrir / cerrar ---------- */

  function open() {
    if (drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-drawer-open');
    var closeBtn = qs('[data-cart-drawer-close].cd__close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function close() {
    if (!drawer.classList.contains('is-open')) return;
    saveAttributesNow();
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function refreshAndOpen() {
    open();
    setLoading(true);
    return refresh()
      .catch(function () {})
      .then(function () { setLoading(false); });
  }

  /* ---------- Cantidades ---------- */

  function changeQty(key, qty) {
    qty = parseInt(qty, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    return run(function () {
      return request('cart/change.js', { id: key, quantity: qty }).then(refresh);
    });
  }

  /* ---------- Packaging de marca ---------- */

  function setPackagingQty(handle, variantId, qty) {
    return getCart().then(function (cart) {
      var line = (cart.items || []).filter(function (item) { return item.handle === handle; })[0];
      if (qty <= 0) {
        if (!line) return null;
        return request('cart/change.js', { id: line.key, quantity: 0 });
      }
      if (line) return request('cart/change.js', { id: line.key, quantity: qty });
      return request('cart/add.js', { items: [{ id: parseInt(variantId, 10), quantity: qty }] });
    });
  }

  /* Los SKUs de la lista llevan packaging Camariñas automáticamente (misma lógica que la página de carrito) */
  function ensureAutoPackaging() {
    var cfg = config();
    if (autoPackagingRunning || !cfg.autoPackagingVariantId || !qs('[data-cart-drawer-content]')) return null;
    var skus = cfg.autoPackagingSkus || [];
    var handles = cfg.packagingHandles || [];
    autoPackagingRunning = true;
    return getCart()
      .then(function (cart) {
        var items = cart.items || [];
        var hasAutoSku = items.some(function (item) { return skus.indexOf(item.sku) !== -1; });
        var hasPackaging = items.some(function (item) { return handles.indexOf(item.handle) !== -1; });
        if (!hasAutoSku || hasPackaging) return null;
        return setPackagingQty(cfg.autoPackagingHandle, cfg.autoPackagingVariantId, 1).then(refresh);
      })
      .catch(function (err) { console.warn('Auto packaging error:', err); })
      .then(function () { autoPackagingRunning = false; });
  }

  /* ---------- Mensaje de regalo ---------- */

  function giftValue(name) {
    var el = qs('[data-gift-field="' + name + '"]');
    return el ? el.value : '';
  }

  function buildNote() {
    return 'From: ' + giftValue('gift-from') +
      '\nTo: ' + giftValue('gift-to') +
      '\nMessage: ' + giftValue('gift-message') +
      '\nSpecial Requests: ' + giftValue('gift-special-requests');
  }

  function toggleGiftFields() {
    var toggle = qs('[data-gift-toggle]');
    var fields = qs('[data-gift-fields]');
    if (toggle && fields) fields.hidden = !toggle.checked;
  }

  function saveAttributesNow() {
    clearTimeout(saveTimer);
    var toggle = qs('[data-gift-toggle]');
    if (!toggle || !giftDirty) return null;
    giftDirty = false;
    return request('cart/update.js', {
      attributes: {
        'is-gift': toggle.checked ? 'yes' : '',
        'gift-from': giftValue('gift-from'),
        'gift-to': giftValue('gift-to'),
        'gift-message': giftValue('gift-message'),
        'gift-special-requests': giftValue('gift-special-requests')
      },
      note: buildNote()
    }).catch(function (err) { console.warn('Gift attributes error:', err); });
  }

  function saveAttributesLater() {
    giftDirty = true;
    clearTimeout(saveTimer);
    saveTimer = setTimeout(saveAttributesNow, 600);
  }

  /* ---------- Código promocional ---------- */

  function showDiscountMessage(text, isError) {
    var el = qs('[data-discount-message]');
    if (!el) return;
    el.textContent = text;
    el.classList.toggle('is-error', !!isError);
    el.hidden = !text;
  }

  function applicableCodes(cart) {
    return (cart.discount_codes || [])
      .filter(function (d) { return d.applicable; })
      .map(function (d) { return d.code; });
  }

  function redirectToDiscount(code) {
    window.location.href = url('discount/' + encodeURIComponent(code)) + '?redirect=' + encodeURIComponent(url('cart'));
  }

  function privateGiftLines(cart, cfg) {
    return (cart.items || []).filter(function (item) {
      return item.handle === cfg.privateGiftHandle &&
        item.properties && item.properties._Private_Gift === cfg.privateGiftCode;
    });
  }

  function showInitialPicker(show) {
    var picker = qs('[data-gift-initials]');
    if (!picker) return;
    picker.hidden = !show;
    if (show) picker.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  /*
   * PRIVATEGIFT regala la Mini Pouch con inicial: si aún no está en el carrito,
   * primero se muestra el selector de iniciales y el código se aplica al elegir una.
   */
  function applyDiscount() {
    var cfg = config();
    var input = qs('[data-discount-input]');
    var code = input ? input.value.trim() : '';
    if (!code) {
      showDiscountMessage(cfg.strings.enterCode, true);
      return Promise.resolve();
    }
    if (code.toUpperCase() !== cfg.privateGiftCode) return applyCode(code, null);
    if (!cfg.privateGiftHandle || !qs('[data-gift-initials]')) return applyCode(code, null);

    return getCart().then(function (cart) {
      if (privateGiftLines(cart, cfg).length) return applyCode(code, null);
      showDiscountMessage('', false);
      showInitialPicker(true);
      return null;
    });
  }

  function applyCode(code, giftVariantId) {
    var cfg = config();
    var result = { text: '', error: false };

    return run(function () {
      var previous = [];
      var addedGiftKey = null;
      return getCart()
        .then(function (cart) {
          previous = applicableCodes(cart);
          if (!giftVariantId) return null;
          return request('cart/add.js', {
            items: [{
              id: giftVariantId,
              quantity: 1,
              properties: { '_Private_Gift': cfg.privateGiftCode, '_Gift': 'Complimentary gift' }
            }]
          }).then(function (res) {
            addedGiftKey = res.items && res.items[0] ? res.items[0].key : null;
          });
        })
        .then(function () {
          var codes = previous.filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });
          codes.push(code);
          return request('cart/update.js', { discount: codes.join(',') });
        })
        .then(function (cart) {
          if (!Array.isArray(cart.discount_codes)) {
            redirectToDiscount(code);
            return new Promise(function () {});
          }
          var entry = cart.discount_codes.filter(function (d) { return d.code.toUpperCase() === code.toUpperCase(); })[0];
          if (entry && entry.applicable) {
            result = { text: cfg.strings.applied, error: false };
            return null;
          }
          result = { text: cfg.strings.invalidCode, error: true };
          return request('cart/update.js', { discount: previous.join(',') }).then(function () {
            if (addedGiftKey) return request('cart/change.js', { id: addedGiftKey, quantity: 0 });
            return null;
          });
        })
        .then(refresh)
        .then(function () {
          var details = qs('details[data-acc="promo"]');
          if (details) details.open = true;
          var freshInput = qs('[data-discount-input]');
          if (freshInput && !result.error) freshInput.value = '';
          showInitialPicker(false);
          showDiscountMessage(result.text, result.error);
        });
    });
  }

  function removeDiscount(code) {
    var cfg = config();
    return run(function () {
      return getCart()
        .then(function (cart) {
          var remaining = applicableCodes(cart).filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });
          return request('cart/update.js', { discount: remaining.join(',') }).then(function () {
            if (code.toUpperCase() !== cfg.privateGiftCode) return null;
            var updates = {};
            privateGiftLines(cart, cfg).forEach(function (item) { updates[item.key] = 0; });
            if (!Object.keys(updates).length) return null;
            return request('cart/update.js', { updates: updates });
          });
        })
        .then(refresh);
    });
  }

  /* ---------- Eventos ---------- */

  drawer.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-cart-drawer-close]')) {
      e.preventDefault();
      close();
      return;
    }

    var qtyBtn = t.closest('[data-qty-change]');
    if (qtyBtn) {
      changeQty(qtyBtn.getAttribute('data-key'), qtyBtn.getAttribute('data-qty-change'));
      return;
    }

    var removeBtn = t.closest('[data-remove]');
    if (removeBtn) {
      changeQty(removeBtn.getAttribute('data-key'), 0);
      return;
    }

    if (t.closest('[data-apply-discount]')) {
      applyDiscount();
      return;
    }

    var initialBtn = t.closest('[data-gift-initial]');
    if (initialBtn && !initialBtn.disabled) {
      var codeInput = qs('[data-discount-input]');
      var giftCode = codeInput && codeInput.value.trim() ? codeInput.value.trim() : config().privateGiftCode;
      applyCode(giftCode, parseInt(initialBtn.getAttribute('data-gift-initial'), 10));
      return;
    }

    var removeCode = t.closest('[data-remove-discount]');
    if (removeCode) {
      removeDiscount(removeCode.getAttribute('data-remove-discount'));
      return;
    }

    var packagingBtn = t.closest('[data-packaging-set]');
    if (packagingBtn) {
      var option = packagingBtn.closest('[data-packaging-option]');
      var target = parseInt(packagingBtn.getAttribute('data-packaging-set'), 10) || 0;
      run(function () {
        return setPackagingQty(option.getAttribute('data-handle'), option.getAttribute('data-variant-id'), target).then(refresh);
      });
    }
  });

  drawer.addEventListener('change', function (e) {
    var t = e.target;

    if (t.matches('[data-qty-input]')) {
      changeQty(t.getAttribute('data-key'), t.value);
      return;
    }

    if (t.matches('[data-gift-toggle]')) {
      toggleGiftFields();
      giftDirty = true;
      saveAttributesNow();
    }
  });

  drawer.addEventListener('input', function (e) {
    if (e.target.matches('[data-gift-field]')) saveAttributesLater();
  });

  drawer.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-discount-input]')) {
      e.preventDefault();
      applyDiscount();
    }
  });

  /* Al pagar: la nota se monta igual que en la página de carrito */
  drawer.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-cart-drawer-form]')) return;
    clearTimeout(saveTimer);
    var note = qs('[data-gift-note]', form);
    if (note) note.value = buildNote();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  /* Deslizar hacia la derecha cierra el carrito en móvil (salvo dentro del slider de packaging) */
  var touchStartX = null;
  var touchStartY = null;
  drawer.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1 || e.target.closest('.cd-slider')) {
      touchStartX = null;
      return;
    }
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });
  drawer.addEventListener('touchend', function (e) {
    if (touchStartX === null) return;
    var dx = e.changedTouches[0].clientX - touchStartX;
    var dy = e.changedTouches[0].clientY - touchStartY;
    touchStartX = null;
    if (dx > 80 && Math.abs(dx) > Math.abs(dy) * 1.5) close();
  }, { passive: true });

  /* Pestaña fija en el lateral para volver a abrir el carrito */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-tab]')) refreshAndOpen();
  });

  /* Enlace "Cart (n)" de la cabecera */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest('a[href]');
    if (!link || drawer.contains(link)) return;
    var path = link.pathname ? link.pathname.replace(/\/$/, '') : '';
    if (link.origin !== window.location.origin) return;
    if (path !== '/cart' && path !== ROOT.replace(/\/$/, '') + '/cart') return;
    e.preventDefault();
    refreshAndOpen();
  });

  /*
   * Añadir desde cualquier formulario de producto (la ficha tiene uno para móvil y otro para ordenador,
   * y bundle.js solo escucha el primero). Se escucha en burbuja para respetar antes los scripts propios
   * del formulario (p. ej. el popup de bordado); si alguno ya ha gestionado el envío, no se hace nada.
   */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented || !form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();

    var submitter = e.submitter || form.querySelector('[type="submit"]');
    if (submitter) submitter.disabled = true;

    fetch(url('cart/add.js'), {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (res) {
        return res.json().then(function (json) { return { ok: res.ok, json: json }; });
      })
      .then(function (result) {
        if (!result.ok) {
          window.alert(result.json.description || result.json.message || config().strings.error);
          return null;
        }
        return refreshAndOpen();
      })
      .catch(function () {
        HTMLFormElement.prototype.submit.call(form);
      })
      .then(function () {
        if (submitter) submitter.disabled = false;
      });
  });

  /* Añadir desde la ficha (bundle.js usa $.ajax) */
  if (window.jQuery) {
    window.jQuery(document).on('ajaxSuccess', function (event, xhr, settings) {
      if (settings && typeof settings.url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(settings.url)) {
        refreshAndOpen();
      }
    });
  }

  window.HeimatCartDrawer = {
    open: refreshAndOpen,
    close: close,
    refresh: refresh
  };
})();
